import { render } from "./CurrencyComponent.vue?vue&type=template&id=6c1e1059"
import script from "./CurrencyComponent.vue?vue&type=script&lang=js"
export * from "./CurrencyComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__